import { Forms, Help, StringHelpers, SystemText } from '@salesperformanceint/e4shared';
import React from 'react';
import { apiGet } from 'services';

export const SFTPValidation = async (host, port, username, password, files, errors, user) => {
    const error = field => SystemText('Admin/General/Modal/Errors/Missing', field);
    let valid = true;
    const filesParsed = files ? JSON.parse(files) : [];

    const st = (path, ...extra) => SystemText(`Admin/Integrations/SFTP/${path}`, ...extra);
    const validFile = /^[\-A-Z0-9+&@#\/%?=~_|!:]+(-YYMM\.csv)$/gi;
    errors.sftpLocation = {};
    if (!host) errors.sftpLocation.host = error(st('Fields/Host/Label'));
    if (!port) errors.sftpLocation.port = error(st('Fields/Port/Label'));
    if (!username) errors.sftpLocation.username = error(st('Fields/Username/Label'));
    if (!password) errors.sftpLocation.password = error(st('Fields/Password/Label'));
    if (filesParsed?.filter(x => x.name).length === 0) {
        errors.sftpLocation.files = error(st('Fields/Files/Label'));
    } else if (filesParsed?.filter(x => !StringHelpers.matchRegEx(validFile, x.name)).length) {
        errors.sftpLocation.files = st('Fields/Files/Error/Name');
    }

    if (Object.keys(errors.sftpLocation).length === 0) {
        const filenames = filesParsed.reduce((a, c) => {
            return a ? `,${c.name}` : c.name;
        }, '');

        const apiCall = apiGet(
            `integrations/sftp-check?ho=${host}&po=${port}&us=${username}&pa=${password}&fi=${filenames}`,
            user.guid,
            response => {
                if (response.error) {
                    errors.sftpLocation.host = response.error;
                    valid = false;
                }
            }
        );

        await apiCall;
    } else {
        return Object.keys(errors.sftpLocation).length === 0;
    }

    return valid;
};

export const SFTP = ({
    host,
    port,
    username,
    password,
    files,
    setHost,
    setPort,
    setUsername,
    setPassword,
    setFiles,
    errors = {},
}) => {
    const st = (path, ...extra) => SystemText(`Admin/Integrations/SFTP/${path}`, ...extra);

    const getFiles = () => {
        return files ? JSON.parse(files) : [{ name: '', daily: false }];
    };

    const addFile = () => {
        const temp = [...getFiles()];
        temp.push({ name: '', daily: false });
        setFiles(JSON.stringify(temp));
    };

    const removeFile = i => {
        const temp = [...getFiles()];
        temp.splice(i, 1);
        setFiles(JSON.stringify(temp));
    };

    const setFileName = (e, i) => {
        const temp = [...getFiles()];
        temp[i].name = e.target.value;
        setFiles(JSON.stringify(temp));
    };

    const setFileDaily = (e, i) => {
        const temp = [...getFiles()];
        temp[i].daily = e.target.checked;
        setFiles(JSON.stringify(temp));
    };

    return (
        <div>
            <Forms.Text
                key="sftpHost"
                data-testid="sftpHost"
                error={errors.host}
                mandatory
                label={st('Fields/Host/Label')}
                help={st('Fields/Host/Help')}
                placeholder={st('Fields/Host/Placeholder')}
                onChange={e => setHost(e)}
                value={host}
            />
            <Forms.Text
                key="sftpPort"
                data-testid="sftpPort"
                error={errors.port}
                mandatory
                type="number"
                label={st('Fields/Port/Label')}
                help={st('Fields/Port/Help')}
                onChange={e => setPort(e)}
                value={port}
            />
            <Forms.Text
                key="sftpUsername"
                data-testid="sftpUsername"
                error={errors.username}
                mandatory
                label={st('Fields/Username/Label')}
                help={st('Fields/Username/Help')}
                onChange={e => setUsername(e)}
                value={username}
            />
            <Forms.Text
                type="password"
                key="sftpPassword"
                error={errors.password}
                data-testid="sftpPassword"
                mandatory
                label={st('Fields/Password/Label')}
                help={st('Fields/Password/Help')}
                onChange={e => setPassword(e)}
                value={password}
            />
            <div data-testid="sftpFiles" className={`form-group ${errors.files ? 'has-error' : ''}`}>
                <label>
                    <div className="flex flex-center">
                        <div className="flex-grow">
                            {st('Fields/Files/Label')}
                            <span className="mandatory">*</span>
                        </div>
                    </div>
                    <span className="form-control-help">
                        <span className="copy">{st('Fields/Files/Help')}</span>
                    </span>
                </label>
                {getFiles().map((file, i) => (
                    <div className="flex flex-center mb10" key={`file-${i}`}>
                        <span className="flex-grow mr10 ">
                            <input
                                role="textbox"
                                className="form-control"
                                value={file.name}
                                onChange={e => setFileName(e, i)}
                                placeholder={st('Fields/Files/Placeholder')}
                            />
                        </span>
                        <span className="flex flex-row flex-center">
                            <input
                                type="checkbox"
                                className="m0"
                                checked={file.daily}
                                id={`file-daily-${file.name}`}
                                onChange={e => setFileDaily(e, i)}
                            />
                            <label
                                htmlFor={`file-daily-${file.name}`}
                                className="m0 pr10 pl5"
                                aria-label={st('Fields/Daily/Help')}
                            >
                                <Help target={<span>{st('Fields/Daily/Label')}</span>} id={`daily-help-${i}`}>
                                    {st('Fields/Daily/Help')}
                                </Help>
                            </label>
                            {getFiles().length > 1 && (
                                <button onClick={() => removeFile(i)} className="btn-link" title={st('Fields/Files/Remove')}>
                                    <i className="fa fa-trash text-danger" />
                                </button>
                            )}
                        </span>
                    </div>
                ))}
                {errors.files && <span className="help-block">{errors.files}</span>}
                <button className="btn-link" onClick={addFile}>
                    {st('Fields/Files/AddAnother')}
                </button>
            </div>
        </div>
    );
};

export default SFTP;
